import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatCard } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { AuthService } from '@mybitzer/core/auth/auth.service'
import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'lib-not-authorized',
  templateUrl: './not-authorized.component.html',
  styleUrl: './not-authorized.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, MatButtonModule, TranslatePipe, MatCard]
})
export class NotAuthorizedComponent {
  readonly contactEmail = input<string>()

  protected auth = inject(AuthService)

  protected logout() {
    this.auth.logout(window.location.origin + '/')
  }

  contactSupport() {
    window.location.href = 'mailto:support@mybitzer.com?subject=Access Request - MyBITZER Back Office'
  }
}
